import React from "react";

import Text from "src/components/text";

import { Analytics, CollectionItem } from "src/types/reports";

import styles from "./collectionActivityList.module.scss";

export interface CollectionActivityItem {
  collection: CollectionItem;
  analytics: Analytics;
}

interface CollectionActivityListProps {
  item: CollectionActivityItem;
  columnCount: number;
}

const CollectionActivityListItem: React.FC<CollectionActivityListProps> = ({ item, columnCount }) => {
  const { collection, analytics } = item;

  const createdBy = collection.createdBy?.firstName
  ? `${collection.createdBy.firstName} ${collection.createdBy.lastName || ""}`.trim()
  : "Unknown";

  return (
    <div className={styles.tableRow}>
      <div className={styles.tableDataContainer}>
        <img
          src={
            collection.icon?.thumbnail ||
            "/images/defaultIcons/default_asset.jpg"
          }
          alt={collection.name}
          className={styles.thumbnailIcon}
        />
        <a
          href={`/collections/${collection.id}`}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.linkWrapper}
        >
          <div className={styles.rightData}>
            <div className={styles.tableDataTitle}>
              <Text
                text={collection.name}
                className={styles.title}
                lines={1}
              />
            </div>
            <div className={styles.metricsData}>
              {collection.assetsCount || 0} Assets
            </div>
          </div>
        </a>
      </div>
      <div
        className={styles.analyticsContainer}
        style={{ gridTemplateColumns: `repeat(${columnCount}, minmax(0, 1fr))` }}
      >
        <div className={styles.tableDataViews}>
          <Text text={createdBy} className={styles.author} lines={1} />
        </div>
        <div className={styles.tableDataViews}>
          {collection.createdDate &&
            new Date(collection.createdDate).toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "short",
              year: "numeric",
            })}
        </div>
        <div className={styles.tableDataViews}>
          {collection.modifiedDate &&
            new Date(collection.modifiedDate).toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "short",
              year: "numeric",
            })}
        </div>
        <div className={styles.tableDataViews}>{analytics.shares}</div>
        <div className={styles.tableDataTime}>{analytics.views}</div>
      </div>
    </div>
  );
};

export default CollectionActivityListItem;
